// Generated by Melange


function makeProps(ariaLabel, children, className, hash, hashScrollIntoView, params, resetScroll, _to, param) {
  return {
    "aria-label": ariaLabel,
    children: children,
    className: className,
    hash: hash,
    hashScrollIntoView: hashScrollIntoView,
    params: params,
    resetScroll: resetScroll,
    to: _to
  };
}

export {
  makeProps,
}
/* No side effect */
